export const snakeCaseToLowerCase = (name: string) => {
  return name.replace(/_/g, '').toLowerCase();
};
